export default __webpack_public_path__ + "static/media/vehicle.00d158d4.svg";